import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import appointmentActions from '../../Actions/appointmentActions'
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { Outlet } from "react-router-dom";
import { DefaultCard } from "../../Components/Card/Card";
import { NoInformation } from "../../Components/Panel";

function AppointmentsContainer({appointmentActions, t, customer, appointments}) {
    
    useEffect(() => {
        appointmentActions.getCustomerAppointments(customer.vbCustomer.customerNumber);
    }, []);
    
    const styleStatusCell = (appointment) => {
        if(appointment.isExpiredAndUnchanged) {
            return 'red';
        }

        if(appointment.isFutureAppointment && appointment.status === 0) {
            return 'bold';
        }

        return null;
    }
    
    if(!appointments) {
        return null;
    }
    
    return <><DefaultCard title={t('appointmentscontainer.header')}>
            <div className="mb-16">
                <Link to={customerRoutes.New} className="btn btn-primary btn-sm">{t('appointmentscontainer.addnew')}</Link>
            </div>
            {appointments.length > 0 ? <div className="table-responsive">
                <table className="table table-stripe">
                    <thead>
                    <tr>
                        <th className="text-left">{t('appointmentscontainer.assignee')}</th>
                        <th className="text-left">{t('appointmentscontainer.subject')}</th>
                        <th className="text-left">{t('appointmentscontainer.time')}</th>
                        <th className="text-left">{t('appointmentscontainer.status')}</th>
                        <th className="text-center" width="50"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {appointments.map((appointment, index) => {
                        return <tr key={index}>
                            <td>{appointment.assigneeName || appointment.assignee}</td>
                            <td>{appointment.subject}</td>
                            <td>{appointment.time}</td>
                            <td className={styleStatusCell(appointment)}>{appointment.status}</td>
                            <td className="text-center"><Link to={`${appointment.id}`}><span className="vismaicon vismaicon-edit" title="Edit" /></Link></td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div> : <NoInformation/>}
        </DefaultCard>
        <Outlet />
    </>
}

function mapStateToProps(state) {
    return {
        appointments: state.AppointmentReducer.customerAppointments,
        customer: state.CustomerReducer.customer
    }
}

function mapDispatchToProps(dispatch) {
   return {
       appointmentActions : bindActionCreators(appointmentActions, dispatch) 
    } 
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AppointmentsContainer));